import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { XCustomTabsFilter, XThemeContainer } from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import TabPane from 'antd/es/tabs/TabPane';
import { Col, Button, Result, Row } from 'antd';
import { useNavigate } from 'react-router-dom';

import UserManagement from './UserManagement';
import RoleManagement from './RoleManagement';
// Actions
import { createRoleApi, createRoleReset } from '../../actions/createRoleAction';
import Header from '../../components/Header/Header';
import { checkModulePermissions } from '../../utils/helper';
import AdminConfigurations from './AdminConfigurations';
import ModuleManagement from './ModuleManagement';
import DefaultRoleManagement from './DefaultRoleManagement';
import GlobalLLMConfigurationManagement from './GlobalLLMConfigurationManagement';
import { XTheme2MainTitle } from '../../styles/GlobalThemeStyleCQ';
import { XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';

const LLM_TAB_FLAG = 'unlock_llm_configuration_tab';

const SECRET_UNLOCK_WINDOW = 3000;

const Manage = (props) => {
	const navigate = useNavigate();
	const [displayOrganization, setDisplayOrganization] = useState(false);
	const [llmTabUnlocked, setLlmTabUnlocked] = useState(
		() => localStorage.getItem(LLM_TAB_FLAG) === 'true',
	);
	const [secretClickState, setSecretClickState] = useState({
		count: 0,
		startTime: 0,
	});

	const handleTabChange = (key) => {
		// Clear the URL search parameters when changing tabs
		navigate(`/user-role-management`);
	};

	useEffect(() => {
		if (localStorage.getItem('role') === 'super-admin')
			setDisplayOrganization(true);
	}, []);


	const headerTag = 'User & Role Management';
	const llmTabLabel = 'Advanced Settings';
	const handleSecretToggle = () => {
		const now = Date.now();
		if (
			!secretClickState.startTime ||
			now - secretClickState.startTime > SECRET_UNLOCK_WINDOW
		) {
			setSecretClickState({ count: 1, startTime: now });
			return;
		}

		const newCount = secretClickState.count + 1;
		if (
			newCount >= 5 &&
			now - secretClickState.startTime <= SECRET_UNLOCK_WINDOW
		) {
			const nextUnlockState = !llmTabUnlocked;
			setLlmTabUnlocked(nextUnlockState);
			setSecretClickState({ count: 0, startTime: 0 });
			if (nextUnlockState) {
				localStorage.setItem(LLM_TAB_FLAG, 'true');
			} else {
				localStorage.removeItem(LLM_TAB_FLAG);
			}
		} else {
			setSecretClickState({
				count: newCount,
				startTime: secretClickState.startTime,
			});
		}
	};

	return (
		<>
			<>
				<Col lg={24} xl={24} xs={0} md={0}>
					<Header headerTag={headerTag} />
				</Col>
				<Col lg={0} xl={0} xs={24} md={24}>
					<HeaderFile activeNav="userRoleManagement" />
				</Col>
			</>
			<XThemeContainer fluid>
				<>
					<Row gutter={[15, 15]} className="align-items-center mb-4">
						<Col
							xs={24}
							sm={24}
							md={12}
							lg={12}
							xl={12}
							className="text-center text-md-start"
						>
							<XTheme2MainTitle className="mb-2">
								User & Role Management
							</XTheme2MainTitle>
							<XTheme2Para1>
								View and manage user role details
							</XTheme2Para1>
						</Col>
					</Row>
					<XCustomTabsFilter
						defaultActiveKey="1"
						// activeKey={1}
						type="card"
						onChange={handleTabChange}
					>
						<TabPane key="1" tab="User Management">
							{checkModulePermissions('user-management')
								.authorized ? (
								<UserManagement />
							) : (
								<Result
									status="403"
									title="403"
									subTitle="Sorry, you are not authorized to access this page."
									extra={
										<Button
											type="primary"
											onClick={() => navigate('/')}
										>
											Back Home
										</Button>
									}
								/>
							)}
						</TabPane>
						<TabPane
							key="2"
							tab="Role Management"
							disabled={
								checkModulePermissions('role-management')
									.authorized
									? false
									: true
							}
						>
							{checkModulePermissions('role-management')
								.authorized ? (
								<RoleManagement />
							) : (
								<Result
									status="403"
									title="403"
									subTitle="Sorry, you are not authorized to access this page."
									extra={
										<Button
											type="primary"
											onClick={() => navigate('/')}
										>
											Back Home
										</Button>
									}
								/>
							)}
						</TabPane>
						{checkModulePermissions('configurations').authorized ? (
							<TabPane key="3" tab="Configurations">
								{checkModulePermissions('configurations')
									.authorized ? (
									<AdminConfigurations />
								) : (
									<Result
										status="403"
										title="403"
										subTitle="Sorry, you are not authorized to access this page."
										extra={
											<Button
												type="primary"
												onClick={() => navigate('/')}
											>
												Back Home
											</Button>
										}
									/>
								)}
							</TabPane>
						) : (
							<></>
						)}
						{checkModulePermissions('module-management')
							.authorized ? (
							<TabPane key="4" tab="Modules">
								{checkModulePermissions('module-management')
									.authorized ? (
									<ModuleManagement />
								) : (
									<Result
										status="403"
										title="403"
										subTitle="Sorry, you are not authorized to access this page."
										extra={
											<Button
												type="primary"
												onClick={() => navigate('/')}
											>
												Back Home
											</Button>
										}
									/>
								)}
							</TabPane>
						) : (
							<></>
						)}
						{displayOrganization ? (
							<TabPane key="5" tab="Default Role Management">
								<DefaultRoleManagement />
							</TabPane>
						) : (
							<></>
						)}
						{displayOrganization && llmTabUnlocked ? (
							<TabPane key="6" tab={llmTabLabel}>
								<GlobalLLMConfigurationManagement />
							</TabPane>
						) : (
							<></>
						)}
					</XCustomTabsFilter>
					<div
						style={{
							display: 'flex',
							justifyContent: 'flex-end',
						}}
					>
						<div
							onClick={handleSecretToggle}
							style={{
								width: '6px',
								height: '6px',
								borderRadius: '50%',
								background: '#2ecc71',
								cursor: 'pointer',
							}}
						></div>
					</div>
				</>
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	createRoleState: state.createRole,
});

const mapDispatchToProps = (dispatch) => ({
	createRole: (params) => dispatch(createRoleApi(params)),
	createRoleReset: () => dispatch(createRoleReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Manage);
